import React from "react";

export default function Filemanager() {
  return (
    <div>
      <div className="balanceBox">
        <div className="balanceBoxInner bg-light">
          <h2 className="balanceBoxTitle text-center text-dark">
            File manager
          </h2>
        </div>
      </div>
    </div>
  );
}
